import fetch from "@/uilts/request";

export default {
    async open(data) {
        return await fetch.post("Dalian/open", data)
    },
    async submit(data) {
        return await fetch.post("Dalian/submit", data)
    },
    async status(data) {
        return await fetch.post("Dalian/status", data)
    },
    async getLink(data) {
        return await fetch.post("Dalian/getLink", data)
    },
    async getSignLink(data) {
        return await fetch.post("Dalian/getSignLink", data)
    },
    async getContractFile(data) {
        return await fetch.post("Dalian/getContractFile", data)
    },
}
